import styled from 'styled-components/macro';
import {
  StyledButtonWrapper,
  StyledFocusableActionsWrapper,
  StyledModalTitle,
} from 'components/Modal/StyledComponents';
import scaleSize from 'utils/scale-size';
import Button from 'components/Button';

export const StyledActionsWrapper = styled(StyledFocusableActionsWrapper)`
  display: table;
  width: 100%;
  ${({ isAdditionalPkg }) => `height: ${scaleSize(isAdditionalPkg ? 300 : 210)}px;`}
`;

export const StyledButtonsArea = styled(StyledButtonWrapper)`
  display: table-cell;
`;

export const StyledTitle = styled(StyledModalTitle)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledStatus = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.activeColor};

  font-size: ${scaleSize(28)}px;
  line-height: ${scaleSize(1.7, false)};
  padding-top: ${scaleSize(25)}px;
`;

export const StyledPrice = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.defaultColor};

  font-size: ${scaleSize(28)}px;
  line-height: ${scaleSize(1.7, false)};
  padding-bottom: ${scaleSize(70)}px;
`;

export const StyledButton = styled(Button)`
  margin: ${scaleSize(10)}px 0;
`;
